import { useState } from "react";

const CategoryNode = ({ category, selectedCourses, setSelectedCourses, level = 0 }) => {
  const [expanded, setExpanded] = useState(false);

  const children = category.childrenRecursive || [];
  const courses = category.courses || [];

  const getAllCourseIds = (cat) => {
    let ids = (cat.courses || []).map(c => c.id);
    (cat.childrenRecursive || []).forEach(child => {
      ids = ids.concat(getAllCourseIds(child));
    });
    return ids;
  };

  const allCourseIds = getAllCourseIds(category);

  const isAllSelected =
    allCourseIds.length > 0 &&
    allCourseIds.every(id => selectedCourses.includes(id));

  const isPartiallySelected =
    allCourseIds.some(id => selectedCourses.includes(id)) &&
    !isAllSelected;

  const handleCategoryChange = (checked) => {
    if (checked) {
      setSelectedCourses(prev =>
        [...new Set([...prev, ...allCourseIds])]
      );
    } else {
      setSelectedCourses(prev =>
        prev.filter(id => !allCourseIds.includes(id))
      );
    }
  };

  const handleCourseChange = (courseId, checked) => {
    if (checked) {
      setSelectedCourses(prev => [...prev, courseId]);
    } else {
      setSelectedCourses(prev =>
        prev.filter(id => id !== courseId)
      );
    }
  };

  return (
    <div style={{ marginLeft: level * 20, marginTop: 6, fontFamily: "Tahoma, sans-serif" }}>
      {/* Category Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          background: "#f0f4f8",
          padding: "4px 8px",
          borderRadius: 6,
          marginBottom: 2,
          cursor: "pointer",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
        }}
      >
        {(children.length > 0 || courses.length > 0) && (
          <div
            onClick={() => setExpanded(prev => !prev)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 20,
              height: 20,
              borderRadius: "50%",
              background: "#1890ff",
              color: "#fff",
              fontWeight: "bold",
              marginRight: 8,
              userSelect: "none"
            }}
          >
            {expanded ? "−" : "+"}
          </div>
        )}
        <label style={{ flex: 1 }}>
          <input
            type="checkbox"
            checked={isAllSelected}
            ref={el => { if (el) el.indeterminate = isPartiallySelected; }}
            onChange={(e) => handleCategoryChange(e.target.checked)}
            style={{ marginRight: 6 }}
          />
          <span style={{ fontWeight: 500 }}>{category.title}</span>
        </label>
      </div>

      {/* Children */}
      {expanded && children.map(child => (
        <CategoryNode
          key={child.id}
          category={child}
          selectedCourses={selectedCourses}
          setSelectedCourses={setSelectedCourses}
          level={level + 1}
        />
      ))}

      {/* Courses به عنوان آخرین سطح */}
      {expanded && courses.map(course => (
        <div
          key={course.id}
          style={{
            marginLeft: (level + 1) * 20,
            padding: "6px 10px",
            background: "#ffffff",
            border: "1px solid #d9d9d9",
            borderRadius: 4,
            marginBottom: 4,
            display: "flex",
            alignItems: "center",
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
          }}
        >
          <input
            type="checkbox"
            checked={selectedCourses.includes(course.id)}
            onChange={(e) => handleCourseChange(course.id, e.target.checked)}
            style={{ marginRight: 8 }}
          />
          <span>{course.title}</span>
        </div>
      ))}
    </div>
  );
};

export default CategoryNode;